module.exports = __webpack_public_path__ + "static/media/TheCurseofEelgrassBogBookCover.d7ae1b10.jpg";